import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const OrganizationRow = (props) => {
  const { itemIndex, result } = props;

  function updateLeague(id, name) {
    props.updateState("currentOrganizationId", id);
    props.updateState("currentOrganizationName", name);
  }

  return (
    <tr key={itemIndex}>
      <td>{result.organizationId}</td>
      <td>
        <Link
          to={
            "/organizations/" +
            result.organizationId +
            "/" +
            result.sport +
            "/credentials"
          }
          onClick={(e) => updateLeague(result.organizationId, result.name)}
          className="link"
        >
          {result.name}
        </Link>
      </td>
      <td className="text-right controls-3">
        <Link
          to={
            "/organizations/" +
            result.organizationId +
            "/" +
            result.sport +
            "/credentials"
          }
          onClick={(e) => updateLeague(result.organizationId, result.name)}
          className="btn btn-outline-secondary btn-sm btn-action"
        >
          <i className="fas fa-users"></i>
          {"   "}
          <FormattedMessage
            id="users"
            defaultMessage="Users"
            description="Users"
          />
          <i className="fas fa-chevron-right" />
        </Link>
      </td>
    </tr>
  );
};

export default OrganizationRow;
